import { render, staticRenderFns } from "./GoodsReview.vue?vue&type=template&id=2ddffe0a&scoped=true&"
import script from "./GoodsReview.vue?vue&type=script&lang=js&"
export * from "./GoodsReview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReview.vue?vue&type=style&index=0&id=2ddffe0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddffe0a",
  null
  
)

export default component.exports